import React, { useState } from 'react'
import Modal from '../modal/modal'
import CloseSVG from '../../assets/svg/close.svg'
import FormInput from '../form-input'
import Button from '../button'
import { useSelector } from 'react-redux'
import { useSendWish } from '../../redux/company/hook'

const SendWish = ({ isOpen, closeModal, employeeData }) => {
  const [message, setMessage] = useState()
  const { mutateAsync: sendBirthdayWish, isLoading } = useSendWish()
  const { user } = useSelector((state) => state.userSlice)

  function submit() {
    let payload = {
      employee_id: user.employee_id,
      message,
    }
    sendBirthdayWish(payload).then((result) => {
      closeModal()
    })
  }

  return (
    <>
      <Modal
        scrollable={true}
        className='!max-w-[500px] !rounded-none'
        isOpen={isOpen}
        centered={true}
      >
        <div className='flex flex-col '>
          <div className='px-4 pt-3'>
            <div className='flex flex-row justify-between'>
              <span className='text-base'>
                Wish {employeeData?.first_name} {employeeData?.last_name}
              </span>
              <div className='cursor-pointer' onClick={() => closeModal()}>
                <img src={CloseSVG} alt='' />
              </div>
            </div>
          </div>
          <hr className='divider' />
          <div className='flex flex-col px-4'>
            <FormInput
              label={'Send a wish'}
              name='message'
              placeholder={'Send a wish'}
              onChange={(e) => setMessage(e.target.value)}
              type='text'
              value={message}
            />
            <div className='w-full my-2'>
              <Button
                onClick={submit}
                text={'Done'}
                type='submit'
                loading={isLoading}
                className='h-[35px]'
              />
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default SendWish
